<script setup>
import { computed, ref, watch, onMounted, onBeforeUnmount } from "vue";
import { useDisplay } from "vuetify";
import SideMenu from "@/components/global/SideMenu";
import BeneficiaryDrawer from "@/components/global/drawer/Drawer";
import { useRoute, useRouter } from "vue-router";
import { useGlobalStore, useListStore } from "@/stores";

const { mobile } = useDisplay();
const sidebarOpen = ref(true);

watch(
  mobile,
  (isMobile) => {
    sidebarOpen.value = !isMobile;
  },
  { immediate: true },
);

const globalStore = useGlobalStore();

const route = useRoute();
const router = useRouter();

const snackbar = computed(() => {
  return globalStore.snackbar;
});

const listStore = useListStore();

let intervalId;

onMounted(() => {
  intervalId = setInterval(async () => {
    try {
      await listStore.fetchListHashes();
    } catch (error) {
      console.error("Error fetching list hashes:", error);
    }
  }, 120000); // every 2 minutes
});

onBeforeUnmount(() => {
  clearInterval(intervalId);
});

watch(
  () => route.query.error,
  (errorQuery) => {
    if (errorQuery === "true") {
      globalStore.showSnackbar({
        show: true,
        text: "An error occurred!",
        timeout: 3000,
        type: "error",
        position: "top right",
      });
      router.replace({ query: { ...route.query, error: undefined } });
    }
  },
  { immediate: true },
);
</script>

<template>
  <v-app>
    <v-app-bar
      v-if="mobile && route.path != '/' && route.path != '/reset-password'"
      flat
      density="compact"
    >
      <v-app-bar-nav-icon @click="sidebarOpen = !sidebarOpen" />
    </v-app-bar>
    <SideMenu
      v-if="route.path != '/' && route.path != '/reset-password'"
      v-model="sidebarOpen"
    />
    <div
      v-if="
        mobile &&
        sidebarOpen &&
        route.path != '/' &&
        route.path != '/reset-password'
      "
      style="
        position: fixed;
        inset: 0;
        z-index: 100;
        background: rgba(0, 0, 0, 0.25);
      "
      @click="sidebarOpen = false"
    />
    <v-main>
      <v-snackbar
        v-model="snackbar.show"
        :timeout="snackbar.timeout"
        :color="snackbar.type ? snackbar.type : 'error'"
        :location="snackbar.position ? snackbar.position : 'top right'"
      >
        {{ snackbar.text }}

        <template #actions>
          <v-btn color="white" variant="text" @click="snackbar.show = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <router-view />
      <BeneficiaryDrawer />
    </v-main>
  </v-app>
</template>

<style lang="scss">
.v-container {
  padding: 30px 50px;

  @media (max-width: 599px) {
    padding: 12px;
  }
}
</style>
